<template>
  <div
    class="custom-global-skeleton tw-bg-[#ffffff] tw-min-w-[284px] tw-max-w-[284px] tw-h-[112px] tw-w-[100%] tw-border tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] tw-p-5 tw-border-solid tw-border-[#EFF0F1] tw-rounded-[6px]"
  >
    <!--
 <div class="tw-flex tw-flex-col tw-h-full tw-justify-between">
      <div class="tw-flex tw-justify-between tw-items-center wrapper">
        <span class="custom-global-skeleton-pulse tw-h-[15px] tw-w-[60px]">
        </span>
        <div
          class="custom-global-skeleton-pulse tw-h-[24.5px] tw-w-[60px] tw-rounded-none"
        ></div>
      </div>
      <div class="tw-flex align-items-end">
        <div class="detail-info">
          <div
            class="tw-text-[#211F58] tw-text-[13px] tw-font-[500] tw-flex tw-justify-between tw-items-center"
          >
            <div
              class="custom-global-skeleton-pulse tw-h-[13px] tw-w-[60px] tw-mb-[10px]"
            ></div>
            <div
              class="custom-global-skeleton-pulse tw-h-[13px] tw-w-[80px]"
            ></div>
          </div>
          <div class="tw-text-[#211F58] tw-text-[13px] tw-font-[500]">
            <div class="tw-flex tw-justify-between tw-items-center">
              <div
                class="custom-global-skeleton-pulse tw-h-[13px] tw-w-[60px] tw-mb-[10px]"
              ></div>
              <div
                class="custom-global-skeleton-pulse tw-h-[13px] tw-w-[80px]"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div> 
-->
  </div>
</template>

<style scoped>
.detail-info {
  flex: 1;
}

.inProgress {
  background: linear-gradient(
      0deg,
      rgba(72, 160, 255, 0.15) 0%,
      rgba(72, 160, 255, 0.15) 100%
    ),
    #fff;
  color: #387dff;
}

.notStarted {
  background: var(--ui-orange-soft, #fee5e2);
  color: #f7553c;
}

.complete {
  background: var(--ui-green-soft, #d9ede2);
  color: #01893d;
}

.audited {
  background: linear-gradient(
      0deg,
      rgba(144, 75, 214, 0.15) 0%,
      rgba(144, 75, 214, 0.15) 100%
    ),
    #fff;
  color: #904bd6;
}
</style>
